export default __webpack_public_path__ + "static/media/pvn-arte-7.cedfdf0a.webp";